import { API_BASE_URL } from '../api/backendClient';

/** Max upload size aligned with backend multer limits (disputes + general upload). */
export const MAX_UPLOAD_BYTES = 10 * 1024 * 1024;
export const MAX_UPLOAD_LABEL = '10 MB';

/** Task work submission: images only, 5 MB each. */
export const MAX_TASK_SUBMIT_IMAGE_BYTES = 5 * 1024 * 1024;
export const MAX_TASK_SUBMIT_IMAGE_LABEL = '5 MB';
export const MAX_TASK_SUBMIT_IMAGES = 10;
export const MAX_TASK_SUBMIT_LINKS = 10;

/**
 * Server origin for static `/uploads` (strip trailing `/api` from API base).
 */
export function getBackendOrigin() {
    const base = String(API_BASE_URL || '').trim();
    const origin = base.replace(/\/?api\/?$/i, '').replace(/\/$/, '');

    if (origin) {
        const localOriginPattern =
            /^https?:\/\/(localhost|127\.0\.0\.1|\[::1\])(?::\d+)?$/i;
        if (typeof window !== 'undefined' && localOriginPattern.test(origin)) {
            const host = String(window.location.hostname || '').toLowerCase();
            const isLocalHost =
                host === 'localhost' || host === '127.0.0.1' || host === '::1';
            if (!isLocalHost) return window.location.origin;
        }
        return origin;
    }

    if (typeof window !== 'undefined') return window.location.origin;
    return 'http://localhost:5001';
}

/**
 * Turn stored attachment paths into absolute URLs the browser can open.
 */
export function resolveAttachmentUrl(value) {
    const raw = String(value || '').trim();
    if (!raw) return '';
    if (/^https?:\/\//i.test(raw)) return raw;

    const origin = getBackendOrigin();
    if (raw.startsWith('/uploads/')) return `${origin}${raw}`;
    if (raw.startsWith('uploads/')) return `${origin}/${raw}`;

    if (
        !raw.includes('/') &&
        !raw.includes('\\') &&
        /\.[a-z0-9]{2,8}$/i.test(raw)
    ) {
        return `${origin}/uploads/${raw}`;
    }

    return raw;
}

export function formatFileSizeError(maxLabel = MAX_UPLOAD_LABEL) {
    return `File is too large. Maximum size is ${maxLabel}.`;
}

export function formatTaskImageSizeError() {
    return formatFileSizeError(MAX_TASK_SUBMIT_IMAGE_LABEL);
}
